import { render, staticRenderFns } from "./ArchyvPohybuDokladuList.vue?vue&type=template&id=fc3d5b8c&"
import script from "./ArchyvPohybuDokladuList.vue?vue&type=script&lang=ts&"
export * from "./ArchyvPohybuDokladuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports